"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function MetaformScriptFromJSON(json) {
    return MetaformScriptFromJSONTyped(json, false);
}
exports.MetaformScriptFromJSON = MetaformScriptFromJSON;
function MetaformScriptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'language': json['language'],
        'content': json['content'],
    };
}
exports.MetaformScriptFromJSONTyped = MetaformScriptFromJSONTyped;
function MetaformScriptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'language': value.language,
        'content': value.content,
    };
}
exports.MetaformScriptToJSON = MetaformScriptToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWV0YWZvcm1TY3JpcHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvTWV0YWZvcm1TY3JpcHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUE2QkgsU0FBZ0Isc0JBQXNCLENBQUMsSUFBUztJQUM1QyxPQUFPLDJCQUEyQixDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztBQUNwRCxDQUFDO0FBRkQsd0RBRUM7QUFFRCxTQUFnQiwyQkFBMkIsQ0FBQyxJQUFTLEVBQUUsbUJBQTRCO0lBQy9FLElBQUksQ0FBQyxJQUFJLEtBQUssU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUNwQixVQUFVLEVBQUUsSUFBSSxDQUFDLFVBQVUsQ0FBQztRQUM1QixTQUFTLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQztLQUM3QixDQUFDO0FBQ04sQ0FBQztBQVZELGtFQVVDO0FBRUQsU0FBZ0Isb0JBQW9CLENBQUMsS0FBNkI7SUFDOUQsSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3JCLE9BQU8sU0FBUyxDQUFDO0tBQ3BCO0lBQ0QsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1FBQ2hCLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsTUFBTSxFQUFFLEtBQUssQ0FBQyxJQUFJO1FBQ2xCLFVBQVUsRUFBRSxLQUFLLENBQUMsUUFBUTtRQUMxQixTQUFTLEVBQUUsS0FBSyxDQUFDLE9BQU87S0FDM0IsQ0FBQztBQUNOLENBQUM7QUFiRCxvREFhQyJ9